import { ComponentStack } from "@components";
import styled from "styled-components";

export const ProgressBarContent = styled(ComponentStack)`
  position: absolute;
  left: 6px;
  height: 100%;
`;
